import React from 'react';
import Product from './Product';
import HomeNews from './HomeNews';
import CountdownView from './CountdownView';
import Jfproduct from './Jfproduct';
import TopFooter from './TopFooter';
import CategoriesProduct from './CategorieProduct';
import Seall from './Seall';

function Home() {
    //const targetDate = "2024-12-31T23:59:59";

    return (
        <div className="bg-white">
            <Product />
            <HomeNews />
            <CountdownView />
            <CategoriesProduct />
            <Jfproduct />
            <Seall />
            <TopFooter />
        </div>
    );
}

export default Home;
